import { getPaginatedNodes } from './utils';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_TEAMS_OPTIONS = graphql(`
  query getTeams($filters: GroupFilterInput) {
    groups(filters: $filters) {
      edges {
        node {
          uuid
          name
          description
        }
      }
    }
  }
`);
export function useGetTeams({
  pageNumber = 0,
  pageSize = 1000,
  label,
}: {
  pageNumber?: number;
  pageSize?: number;
  label: string;
}) {
  const filters: { label: string } = {
    label: label,
  };

  const { loading, error, data } = useQuery(GET_TEAMS_OPTIONS, {
    variables: {
      filters: filters,
    },
  });

  const teams = useMemo(() => {
    if (!data || !data.groups || !data.groups.edges) return [];

    return getPaginatedNodes(data.groups).map((edge) => {
      return {
        id: edge?.uuid ?? '--',
        value: edge?.uuid ?? '--',
        label: `${edge?.name}` ?? '',
      };
    });
  }, [data]);

  return {
    error,
    loading,
    data,
    teams,
  };
}
